import request from 'superagent';
import tree from '../state';
import config from '../config';

export const getfaqs = function() {
	return request.get(`${config.apiBase}/api/faq`)
		.set('authorization', tree.get('token'))
		.then(res => JSON.parse(res.text))
	;
};


// WEBPACK FOOTER //
// ./src/services/faqService.js